import React from 'react'
import { EnvironmentRegistry } from '../../../services/registry/environmentRegistry';
import './CompanyPosts.css'
import { getAccessToken } from '../../../services/authenticationService';

function CompanyPosts() {
    const lob = EnvironmentRegistry.getCurrentLob();
    const currentUserLoginId = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user?.loginId;

  return (
    <div className='social_iframe'>
        <iframe
            height={'100%'}
            width={'100%'}
            src={`https://social.salescode.ai/?token=${getAccessToken()}&loginIdPortal=${currentUserLoginId}`}
            title="Salescode AI"
            allowFullScreen
          ></iframe>
    </div>
  )
}

export default CompanyPosts